
import { CartData, RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import { Cart, Button, BUTTON_TYPE} from '@bepure/tarkin';
// import { CartData, ItemDict } from '../Cart/Cart';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ProductDiv from './ProductDiv';
import { fetchBigCommerceApi, HTTP_METHOD } from 'utils/bigCommerceAuth';
import RecommendedProduct from './RecommendedProduct';
import StickyPurchaseButtons from 'components/StickyPurchaseButtons';
import { useEffect, useState } from 'react';

interface Props {
    cart: Cart;
    guid?: string;
    viewProductsLink: string;
    showRecommended?: boolean;
    promoBanner?: string;
}

interface RecommendedProductData {
    productId: number;
    sku: string;
    imageUrl: string;
    imageAltText: string;
    price: number;
    name: string;
    variantId: number;
}


interface AttachShoppingCartParams {
    cartData?: CartData;
    guid?: string;
    viewProductsLink: string;
}

const ShoppingCart = (props: Props) => {
    const [cart, setCart] = useState(Cart.getInstance() || {});
    const [recommendedProducts, setRecommendedProducts] = useState<RecommendedProductData[]>([])
    const [isLoading, setIsLoading] = useState(false);
    const [containsSubscription, setContainsSubscription] = useState(false);
    const [cartLength, setCartLength] = useState(Object.keys(Cart.getInstance().getItems()).length)

    const currency = localStorage.getItem('currency') || 'NZD'
    const items = Object.keys(cart.getItems())
        .filter(productId => cart.getItems()[productId] !== undefined)
        .map(productId => {
            return {...cart.getItems()[productId], productId}
        });


    useEffect(() => {
        Cart.loadCart();
        getRecommendedProducts().then((products: RecommendedProductData[]) => {
            setRecommendedProducts(products)
        })
    },[])

    const getCartItems = () => {
        const items = Object.keys(cart.getItems())
        .filter(productId => cart.getItems()[productId] !== undefined)
        .map(productId => {
            return {...cart.getItems()[productId], productId}
        });
        return items
    }

    const checkForCartLength = () => {
        const items = getCartItems();
        let newItemTotal = 0;
        items.forEach(item => {
            newItemTotal += item.quantity;
        })
        return newItemTotal;
    }

    const checkForSubscriptions = () => {
        const items = getCartItems();
        let subscriptionInCart = false;
        items.forEach(item => {
            if(item.orderIntervalFrequency && item.orderIntervalUnit){
                subscriptionInCart = true;
            }
        })
        return subscriptionInCart;
    }

    const rehydrateCart = () => {
        const newCart = Cart.getInstance();
        setContainsSubscription(checkForSubscriptions())
        setCartLength(checkForCartLength());
        setCart(newCart);
    }
    
    const blurQuantityOfItem = (product: RegularProduct) => {
        return async (value: number) => {
            product.quantity = value || 0;
            await cart.updateItem(product).then(() =>
            rehydrateCart()
            );
        };
    }

    const removeAllQuantityOfItem = (product: RegularProduct) => {
        return () => {
            const updatedProduct = {
                ...product,
                quantity: 0
            };
            cart.updateItem(updatedProduct).then(() => {
                rehydrateCart()
            });
        };
    }
        
    const redirectToProductPage = (event: React.MouseEvent<HTMLButtonElement>) => {
        window.location.href = props.viewProductsLink;
    }
    
    const redirectToCheckout = (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true);
        const cart = Cart.getInstance();
        cart.checkoutCart().catch((error) => {
            // todo:  message to customer.
            console.log("Error in checkout:", error.message);
            // handle error
            cart.clearCart();
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const getRecommendedProducts = async (): Promise<RecommendedProductData[]> => {
        const response = await getBigCommerceRecommendedProducts(); 
        const json = await response.json();
        const products = json.data.site?.bestSellingProducts?.edges.map((node: { node: { [key: string]: any } }) => {
            return {
                productId: node.node.entityId,
                sku: node.node.sku,
                imageUrl: node.node.defaultImage.imageUrl,
                imageAltText: node.node.defaultImage.altText,
                price: node.node.prices.price.value,
                name: node.node.name,
                variantId: node.node.variants.edges.values().next().value.node.entityId
            }
        });
        return products
    }

    const getBigCommerceRecommendedProducts = async (): Promise<any> => {
        return await fetchBigCommerceApi(HTTP_METHOD.POST, new Headers(), {
            query: `query paginateProducts(
                $pageSize: Int = 2
                $cursor: String
                $currencyCode: currencyCode = NZD
                ) {
                    site {
                        bestSellingProducts (first: $pageSize, after:$cursor) {
                            pageInfo {
                                startCursor
                                endCursor
                            }
                            edges {
                                cursor
                                node {
                                    entityId
                                    sku
                                    name
                                    defaultImage {
                                        imageUrl: url(width: 660)
                                        altText
                                    }
                                    variants {
                                        edges {
                                            node {
                                                entityId,
                                                
                                            }
                                        }
                                    },
                                    prices (currencyCode: $currencyCode, includeTax: true) {
                                        price {
                                            value
                                            currencyCode
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                `,
                variables: {
                    currencyCode: localStorage.currency || 'NZD'
                }
            })
        };

    
    
    const itemsJSX: JSX.Element[] = items.map((product, index) => {
            return (
                <ProductDiv
                    key={product.productId}
                    product={(product as RegularProduct)}
                    removeAllQuantityOfItem={removeAllQuantityOfItem(product)}
                    onChangeHandler={blurQuantityOfItem(product)}
                    currency={currency}
                    setContainsSubscription={setContainsSubscription}
                    setCartLength={setCartLength}
                />
            );
        });
    const subtotal: number = items.reduce((acc, currItem) => {
        return acc + currItem?.unit_price * (currItem?.quantity || 1);
    }, 0);
    // this code is just for the visual appearance of the discount on the cart page
    let twoProductDiscount = 0;
    // if(cartLength >1){
    //     twoProductDiscount = 0.05 * subtotal;
    // }
    const total = subtotal - (twoProductDiscount);
    
    
    const hasItems = itemsJSX.length > 0;
    const styles = {
        root: `shopping-cart`,
        cart: `shopping-cart__shopping-cart-container`,
        grid: `shopping-cart__shopping-cart-container__grid-container`,
    }

        
            
            
            return (
                <>
                    <div className={styles.cart}>
                        <section className={`${styles.grid} ${props.promoBanner && 'include_promo'} ${props.showRecommended !== false && 'include_recommended'}`}>
                            <section className={`cart-items`}>
                                <h1 className="page_heading">Shopping Cart</h1>
                                {
                                    hasItems ?
                                    <>
                                    <div className="shopping-cart__items-div">
                                        {itemsJSX}
                                    </div>
                                    </>
                                    :
                                    <div className="shopping-cart__empty-cart-container">
                                        <div className="shopping-cart shopping-cart__empty-cart-container__empty-cart">
                                            You have 0 items in your cart.
                                        </div>
                                        <div className="shopping-cart__empty-cart-container__view_products_div">
                                            <button id={`view_products_cta`} onClick={redirectToProductPage} className={'btn btn--secondary margin'}>VIEW PRODUCTS</button>
                                        </div>
                                    </div>
                                }
                            </section>
                            <section className={`cart-summary`}>
                                <div className={`cart-summary__row`}>
                                    <h2 className={`cart-summary__row__text`}>Subtotal {containsSubscription}</h2>
                                    <p className={`cart-summary__row__text`}>{`$${subtotal.toFixed(2)} ${currency}`}</p>
                                </div>
                                {/* {cartLength > 1 &&
                                    <div className={`cart-summary__row`}>
                                    <h2 className={`cart-summary__row__text`}>Two Product 5% discount {containsSubscription}</h2>
                                    <p className={`cart-summary__row__text`}>{`-$${twoProductDiscount.toFixed(2)} ${currency}`}</p>
                                </div>} */}
                                <div className={`cart-summary__row`}>
                                    <h2 className={`cart-summary__row__text`}>Shipping</h2>
                                    <p className={`cart-summary__row__text`}>Calculated at next step</p>
                                </div>
                                <div className="cart-summary__row">
                                <div className="cart-summary__shipping-container">
                                    <img src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Eve_Shipping_43x27.svg" alt="Shipping Icon"/>
                                    <ul>
                                        <li>Free shipping on NZ orders</li>
                                        <li>Free shipping on AUS orders over $89</li>
                                    </ul>
                                </div>
                                </div>
                                <div className={`cart-summary__row`}>
                                    <h2 className={`cart-summary__row__total`}>Total</h2>
                                    <p className={`cart-summary__row__total`}>{`$${total.toFixed(2)} ${currency}`}</p>
                                </div>
                                {!containsSubscription && cartLength != 0 &&
                                    currency === 'NZD' && <div className={`cart-summary__afterpay`}>{`Or 4x interest free payments of $${(total/4).toFixed(2)} ${currency} with`}
                                        <img alt='afterpaylogo' height={40} src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Afterpay_Badge_BlackonMint.svg" />
                                    </div> 
                                }
                            </section>
                            {/* { props.showRecommended !== false && 
                            <section className={`recommended-products`}>
                                <h2 className={`recommended-products_heading page_heading`}>People also loved</h2>
                                <div className={`cart-upsell`}>Buy two products and receive 5% off your purchase</div>
                                {
                                   recommendedProducts?.map(product => (
                                    <RecommendedProduct
                                        key={product.name}
                                        name={product.name}
                                        sku={product.sku}
                                        imageAltText={product.imageAltText}
                                        imageUrl={product.imageUrl}
                                        price={product.price}
                                        productId={product.productId}
                                        productVariant={product.variantId}
                                        description={"One-off purchase"}
                                        addToCartHandler={rehydrateCart}
                                        setContainsSubscription={setContainsSubscription}
                                    />
                                ))
                                }
                            </section> } */}
                            { props.promoBanner && <section className={`promo-banner`}>{props.promoBanner}</section> }
                            <section className={`checkout-section`}>
                                    <Button
                                        id={'secure_checkout'}
                                        button_type= {BUTTON_TYPE.PRIMARY}
                                        text= {'Checkout Now'}
                                        ariaLabel= {'Secure Checkout'}
                                        onClick= {redirectToCheckout} 
                                        loading={isLoading}
                                    />
                                </section>
                                <StickyPurchaseButtons >
                                    
                                    <Button
                                        id={'secure_checkout'}
                                        button_type= {BUTTON_TYPE.SECONDARY}
                                        text= {'Checkout Now'}
                                        ariaLabel= {'Secure Checkout'}
                                        onClick= {redirectToCheckout} 
                                        loading={isLoading}
                                        otherClasses={'shopping-cart__button__secure-checkout'}
                                        />
                                </StickyPurchaseButtons>
                        </section>
                    </div>
                </>
            );
        
        }

    
    
    export default (params: AttachShoppingCartParams) => {
        const shoppingCartDivs = document.getElementsByClassName('shopping-cart-node');
        Array.from(shoppingCartDivs).forEach((div) => {
        ReactDOM.render(
            <ShoppingCart 
                key={params.guid}
                cart={Cart.getInstance()} 
                guid={params.guid}
                showRecommended={true}
                viewProductsLink={params.viewProductsLink}/>,
            div,
            );
        });
    };
